import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import s from '../TemplateCard.module.scss';
const TemplateCardLinkWrapper = _ref => {
  let {
    template,
    children,
    templateHref,
    anchorProps = {},
    onClick,
    setHover,
    setFocused,
    t
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "aria-labelledby": `template-title-${template.title}`,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => {
      setHover(false);
      template.media?.animatedPreview && setFocused(false);
    }
  }, templateHref ? /*#__PURE__*/React.createElement("a", _extends({
    "data-hook": `template-card-container-${template.id}`,
    href: templateHref,
    "aria-label": t('marketplace.templates-page.view-template-cta'),
    onClick: onClick,
    rel: "noreferrer"
  }, anchorProps, {
    className: anchorProps?.className ? `${s.cardContainer} ${anchorProps.className}` : s.cardContainer
  }), children) : /*#__PURE__*/React.createElement("div", {
    className: anchorProps?.className ? `${s.cardContainer} ${anchorProps.className}` : s.cardContainer,
    "data-hook": `template-card-container-${template.id}`,
    "aria-disabled": "true",
    style: {
      cursor: 'default'
    }
  }, children));
};
export default TemplateCardLinkWrapper;
//# sourceMappingURL=TemplateCardLinkWrapper.js.map